import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bg-white p-10" }
const _hoisted_3 = { class: "text-6xl-quote-long text-gray-500" }
const _hoisted_4 = { class: "mt-6 text-md text-gray-400" }
const _hoisted_5 = ["href", "aria-label"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 h-1/3 w-px bg-black" }, null, -1)

import { inject, onMounted } from 'vue';
import { ScrollItem } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoScrollItem',
  props: {
    title: null,
    text: null,
    link: null,
    linkLabel: null,
    start: null,
    end: null,
    editMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, text?: string, link?: string, linkLabel?: string, start: number, end?: number, editMode: boolean }



const register: (item: ScrollItem) => void = inject('registerItem');

onMounted(() => {
    register(props);
});

return (_ctx: any,_cache: any) => {
  return (__props.editMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.text), 1),
          (__props.link && __props.linkLabel)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "relative mt-6 inline-block border-b border-black px-1.5 text-md text-gray-500",
                href: __props.link,
                target: "_self",
                "aria-label": __props.linkLabel
              }, [
                _createElementVNode("span", null, _toDisplayString(__props.linkLabel), 1),
                _hoisted_6
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})